const notifications = {
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    success: 'Success',
  };

export default notifications;
